import React, { JSX, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import GlobalPostModal from "../boards/GlobalPostModal";
import "./AppLayout.css";

type AppLayoutProps = {
  children: React.ReactNode;
};

export default function AppLayout({ children }: AppLayoutProps): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useAuth();
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;


  return (
    <div className="app-layout">
      {/* Desktop Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/favicon.ico" alt="Logo" className="sidebar-logo-icon" />
          <span>Gratitude Board</span>
        </div>

        {/* Top Navigation */}
        <nav className="sidebar-nav">
          {/* Create Button - Inactive */}
          <button
            className="nav-item"
            onClick={() => setIsPostModalOpen(true)}
            style={{ color: 'var(--accent-primary)' }}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></svg>
            Post
          </button>

          {/* Boards Button */}
          <button
            className={`nav-item ${isActive("/app") ? "active" : ""}`}
            onClick={() => navigate("/app")}
          >
            <div style={{ marginRight: 0 }}>
              <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="9" y1="3" x2="9" y2="21" /></svg>
            </div>
            Boards
          </button>
        </nav>

        {/* Bottom Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {/* Profile Button */}
          <button
            className={`nav-item ${isActive("/profile") ? "active" : ""}`}
            onClick={() => navigate("/profile")}
          >
            <div style={{ marginRight: 0 }}>
              <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
            </div>
            Profile
          </button>

          {/* Sign Out Button */}
          <button
            className="nav-item"
            onClick={async () => {
              await signOut();
              navigate("/");
            }}
            style={{ color: '#ef4444' }}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>

      {/* Mobile Bottom Nav */}
      <nav className="mobile-nav">
        <div
          className={`mobile-nav-item ${isActive("/app") ? "active" : ""}`}
          onClick={() => navigate("/app")}
        >
          <div className="mobile-nav-icon">
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="9" y1="3" x2="9" y2="21" /></svg>
          </div>
          <span className="mobile-nav-label">Boards</span>
        </div>

        <div
          className="mobile-nav-item"
          onClick={() => setIsPostModalOpen(true)}
          style={{ color: 'var(--accent-primary)' }}
        >
          <svg className="mobile-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></svg>
          <span className="mobile-nav-label">Post</span>
        </div>

        <div
          className={`mobile-nav-item ${isActive("/profile") ? "active" : ""}`}
          onClick={() => navigate("/profile")}
        >
          <div className="mobile-nav-icon">
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
          </div>
          <span className="mobile-nav-label">Profile</span>
        </div>
      </nav>

      {/* Global Post Modal */}
      <GlobalPostModal
        open={isPostModalOpen}
        onClose={() => setIsPostModalOpen(false)}
        onPostSuccess={() => { }}
      />
    </div>
  );
}
